import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface RootProps extends ComponentProps<'main'> {}
function root({ className, ...rest }: RootProps) {
  return (
    <main
      className={twMerge(
        'mx-auto flex w-full max-w-5xl flex-col gap-6 space-y-5 px-4 py-8 lg:px-0',
        className,
      )}
      {...rest}
    />
  )
}

interface ContentProps extends ComponentProps<'div'> {}
function content({ className, ...rest }: ContentProps) {
  return <div className={twMerge('flex flex-col gap-6', className)} {...rest} />
}

export const AgentContract = {
  Root: root,
  Content: content,
}
